import {Skeleton, TableCell, TableRow} from "@mui/material";
import {Stack} from "@mui/system";

export const SKELETON_INITIAL_ROWS = 8;
export const SKELETON_PAGE_ROWS = 3;

export function GroupingSettingsSkeletonRow() {
    return (
        <TableRow>
            <TableCell sx={{py: 1.5, width: "42%"}}>
                <Stack direction="row" alignItems="center" gap={1} sx={{minWidth: 0}}>
                    <Skeleton
                        variant="rounded"
                        width={20}
                        height={20}
                        sx={{flexShrink: 0, borderRadius: "6px"}}
                    />
                    <Skeleton variant="text" sx={{flex: 1, maxWidth: "88%"}}/>
                </Stack>
            </TableCell>
            <TableCell align="right" sx={{width: "22%"}}>
                <Skeleton variant="text" width={56} sx={{ml: "auto"}}/>
            </TableCell>
            <TableCell align="right" sx={{width: "18%"}}>
                <Skeleton variant="text" width={36} sx={{ml: "auto"}}/>
            </TableCell>
            <TableCell align="right" sx={{width: "18%"}}>
                <Skeleton variant="text" width={44} sx={{ml: "auto"}}/>
            </TableCell>
        </TableRow>
    );
}